import { render, staticRenderFns } from "./IndicatorOnOff.vue?vue&type=template&id=4af497bb&scoped=true&"
import script from "./IndicatorOnOff.vue?vue&type=script&lang=js&"
export * from "./IndicatorOnOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af497bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4af497bb')) {
      api.createRecord('4af497bb', component.options)
    } else {
      api.reload('4af497bb', component.options)
    }
    module.hot.accept("./IndicatorOnOff.vue?vue&type=template&id=4af497bb&scoped=true&", function () {
      api.rerender('4af497bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/generic/IndicatorOnOff.vue"
export default component.exports